<div class="p-10" *ngIf="FilesNote_DS">
    <div fxLayoutGap="10px" fxLayoutAlign="end center" class="p-10">
        <button (click)="addNewSection()" mat-raised-button>Ajouter un commentaire</button>
        <button (click)="save()" color="primary" mat-raised-button>Enregistrer</button>
    </div>
    <mat-card class="my-10" *ngFor="let item of FilesNote_DS.FilesNote; let i = index">
        <div fxLayoutGap="10px" fxLayoutAlign="end center" class="my-10">
            <button mat-icon-button (click)="deleteSection(i)"><mat-icon>delete</mat-icon></button>
        </div>
        <comment-section [item]="item"></comment-section>
    </mat-card>
</div>
